import { EMBED_APP_EVENTS } from "../core/constants";
import { handlePostMessage } from "./postMessageHandler";
import InDevFeatureFlags from "../all/InDevFeatureFlags";

function isMobileSafari() {
  const ua = window.navigator.userAgent;
  const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  const webkit = !!ua.match(/WebKit/i);

  return iOS && webkit && !ua.match(/CriOS/i);
}

function initialiseIFrameResize(iframe) {
  console.log("initialiseIFrameResize: called %o", iframe);
  if (isMobileSafari()) {
    return;
  }

  const resizeIFrame = function () {
    const frameBody = iframe.contentDocument.body;
    const frameHtml = iframe.contentDocument.documentElement;

    const height = Math.max(
      frameBody.scrollHeight,
      frameBody.offsetHeight,
      frameHtml.clientHeight,
      frameHtml.scrollHeight,
      frameHtml.offsetHeight
    );

    iframe.height = height;
  };

  window.setInterval(resizeIFrame, 500);
}

function waitForFrameToBeReady(iframe) {
  console.log("waitForFrameToBeReady: start %o", iframe);
  return new Promise((resolve) => {
    iframe.addEventListener("load", () => {
      resolve();
    });
  });
}

const initialiseEmbeddedApp = () => {
  GlamCornerCore.bus.on(EMBED_APP_EVENTS.EMBED_APP_LOADED, function (iframe) {
    waitForFrameToBeReady(iframe).then(() => {
      initialiseIFrameResize(iframe);

      // The setTimeout is an experimental weekend quickfix/hack. Have seen addEventListener call fail with:
      //     Failed to execute 'postMessage' on 'DOMWindow': The target origin provided
      //     ('https://subscription-payment.glamcorner.com.au') does not match the recipient window's origin
      //     ('https://www.glamcorner.com.au').
      // even though frameHasRootDomain returned true. Some googling suggests that maybe the frame hasn't
      // loaded. So adding a delay as a very rough quickfix for now.
      //
      // Don't really have any evidence that this is happening. I managed to successfully create a subscription
      // when testing in spite of seeing the error in the console, and the subscription appeared in braintree
      // as well as in GA Goals.
      setTimeout(() => {
        GlamCornerCore.bus.connectIFrame(iframe);

        window.addEventListener("message", handlePostMessage);

        iframe.contentWindow.postMessage(
          {
            type: "inDevFeaturesEnabled",
            data: InDevFeatureFlags.instance().persistentFeatures(),
          },
          iframe.src
        );
      }, 1000);
    });
  });
};

export { initialiseEmbeddedApp };
